// Vai trò người dùng trên hệ thống DVC
// hkcuong 25.12.2025
export default {
  ///Chưa đăng nhập
  NotLogedIn: 0,

  /// Thủ trưởng đơn vị
  HeadOfDepartment: 2,

  /// Kế toán trưởng
  ChiefAccountant: 3,

  ///Uỷ quyền CTK
  DelegateHeadOfDepartment: 4,

  /// Uỷ quyền Kế toán trưởng
  DelegateChiefAccountant: 5,

  ///Kế toán viên
  Accountant: 6,

  ///Khác
  OtherAccountant: 7,
};
